/**
 * LegacyBanner — disclaimer pokazywany u góry stron przeniesionych
 * do sekcji "Legacy (Adam v1)" w sidebar (2026-05-14 IA reorg Etap 1).
 *
 * Cel: jasno komunikować że strona jest zachowana dla istniejących
 * użytkowników ale nie jest częścią głównego flow.
 *
 * Usage:
 *   <LegacyBanner
 *     replacement="Inbox + Composer"
 *     replacementPath="/inbox"
 *     lang={lang}
 *   />
 */

import React, { useState } from 'react';
import { AlertTriangle, ArrowRight, X } from 'lucide-react';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';


export default function LegacyBanner({
  replacement,
  replacementPath,
  reason,
  lang = 'pl',
}) {
  const [hidden, setHidden] = useState(false);
  const navigate = useNavigate();

  if (hidden) return null;

  return (
    <div className="mb-4 border border-amber-500/30 bg-amber-500/10 rounded-lg p-3 flex items-start gap-3">
      <AlertTriangle className="w-4 h-4 text-amber-400 mt-0.5 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-amber-200">
          {lang === 'pl' ? 'Strona Legacy (Adam v1)' : 'Legacy page (Adam v1)'}
        </div>
        <p className="text-xs text-amber-200/80 mt-0.5">
          {reason || (lang === 'pl'
            ? 'Ta funkcja pochodzi z poprzedniej wersji MASKIL i nie jest częścią głównego flow. Zachowana dla istniejących użytkowników — w przyszłości może zostać usunięta.'
            : 'This feature is from the previous MASKIL version and is not part of the main flow. Kept for existing users — may be removed in future.')}
        </p>
        {replacement && replacementPath && (
          <Button
            variant="link"
            size="sm"
            onClick={() => navigate(replacementPath)}
            className="text-amber-300 hover:text-amber-200 h-auto p-0 mt-1 gap-1 text-xs"
          >
            {lang === 'pl' ? 'Przejdź do nowej wersji' : 'Go to new version'}: {replacement}
            <ArrowRight className="w-3 h-3" />
          </Button>
        )}
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setHidden(true)}
        className="h-6 w-6 p-0 text-amber-300/60 hover:text-amber-200"
      >
        <X className="w-3.5 h-3.5" />
      </Button>
    </div>
  );
}
